
import { MDBBtn, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog } from 'mdb-react-ui-kit';
import React, {  useContext, useEffect, useState } from 'react';
import { fetchIPAddress, getDomainsAndCategories, handleAllowLocation } from '../utils/Common';
import { NavbarContext } from '../context/NavProvider';
import { GeographyContext } from '../context/GeographyProvider';
import { UserProfileContext } from '../context/UserProfileProvider';

import { DomainContext } from '../context/DomainProvider';
import { CategoryContext } from '../context/CategoryContext';
import { MiscContext } from '../context/MiscProvider';
function Location() {
  /* global FB */
  const [showModal, setShowModal] = useState(false);
  const {DPM} = useContext(MiscContext);
  const {domainId,selectDomains,setSelectDomains,setGroupedDomainsByDomain,setDomainImages} = useContext(DomainContext);
  const {setSelectCategories,setCategoryImages,setGroupedCategoriesByDomain} = useContext(CategoryContext);
  const {setIPAddress,ipAddress,setLocation,location,setCountry} = useContext(GeographyContext);
  const {isLoginRequired,tokenLoaded} = useContext(UserProfileContext);
  const { setBusiness} = useContext(NavbarContext);
  

  useEffect(() => {

    let webSocket;
    let intervalId; // To store the reference to the interval

    const messageListener = (event) => {
      const message = event.data;
      console.log("Received message:", message);
      if (message === "Deployment done, refresh your browser") {
        setShowModal(!isLoginRequired);
        localStorage.setItem("DPM", "true"); // Store that the message has been received
        clearInterval(intervalId); // Clear the interval once the message is received
      }
    };

    const closeListener = (event) => {
      console.log("WebSocket closed. Reconnecting in 5 seconds...");
      setTimeout(connectWebSocket, 10 * 60 * 1000);
    };

    const errorListener = (error) => {
      console.error("WebSocket Error: ", error);
    };

    const connectWebSocket = () => {
      const hostname = window.location.hostname;
      //  const hostname = 'bheemfoodsl.com:8444';
      // const port = window.location.port;
      let fullAddress = hostname;
      // if (port) {
      //   fullAddress = `${hostname}:${port}`;
      // }

      // Close the previous WebSocket if it exists
      if (webSocket) {
        webSocket.close();
      }
      console.log("host :" + fullAddress);
      webSocket = new WebSocket(`wss://${fullAddress}/wse?ipAddress=${ipAddress}`);

      webSocket.addEventListener("message", messageListener);
      webSocket.addEventListener("close", closeListener);
      webSocket.addEventListener("error", errorListener);
    };

    if (!DPM) {
      connectWebSocket();

      // Set the interval to connect every 1 minute
      intervalId = setInterval(connectWebSocket, 10 * 60 * 1000);
    }

    return () => {
      clearInterval(intervalId); // Clear the interval when the component unmounts
      if (webSocket) {
        webSocket.removeEventListener("message", messageListener);
        webSocket.removeEventListener("close", closeListener);
        webSocket.removeEventListener("error", errorListener);
        webSocket.close();
      }
    };

  }, []);





  const domainFromLocalStorage = localStorage.getItem('DOMAIN');


  useEffect(() => {
   if(!ipAddress){
    fetchIPAddress(setIPAddress);
   }
   
  }, []);


  useEffect(() => { 
    if(selectDomains?.length === 0){  
    getDomainsAndCategories(domainId,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages)
    }
  }, [domainId,  tokenLoaded,  setSelectCategories, setSelectDomains,  setCategoryImages, setDomainImages]);
 
 


  useEffect(() => {

    handleAllowLocation(setLocation,ipAddress,setIPAddress);
  }, []);


  return (

    <MDBModal animationDirection='bottom' open={showModal} tabIndex='-1' frame>
      <MDBModalDialog position='top' frame >
        <MDBModalContent>
          <MDBModalBody className='py-1'>
            <div className='d-flex flex-column flex-md-row justify-content-center align-items-center my-3'>
              <p className='mb-0 mb-md-2 mb-lg-0 text-center text-md-start'>Sorry for the inconvenience. A new version is available; please refresh your browser.</p>
              <div className='d-flex justify-content-center justify-content-md-end mt-2 mt-md-0'>
                <MDBBtn color='success' size='sm' className='ms-2' onClick={() => {
                  setShowModal(false); localStorage.setItem('DOMAIN', 'true');
                  setTimeout(() => window.location.reload(), 500); // delay the refresh slightly
                }}>
                  Refresh</MDBBtn>
                <MDBBtn size='sm' className='ms-2' onClick={() => setShowModal(false)}>
                  Dismiss
                </MDBBtn>
              </div>
            </div>
          </MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>

  );
}


export default Location;
